import variables from '../assets/scss/common/_variables.scss';
export default variables;